import { Fragment } from "react";
import { Grid, MenuItem } from "@mui/material";

import { Label, TextField, LoadingButton } from "../../components";

export default function VisitorFormDisplay({ formikProps }) {
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Label
            required
            title="First Name"
            name="first_name"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            required
            name="first_name"
            placeholder="First Name"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
          />
        </Grid>

        <Grid item xs={6}>
          <Label
            title="Last Name"
            name="last_name"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            name="last_name"
            placeholder="Last Name"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Email Address"
            name="email"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            required
            name="email"
            placeholder="Email Address"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Phone Number"
            name="phone_number"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            required
            name="phone_number"
            placeholder="Phone Number"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
            inputProps={{
              type: "tel",
              maxLength: 10,
              pattern: "[6-9]\\d*",
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Gender"
            name="gender"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            select
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            required
            name="gender"
            placeholder="Select Gender"
            label="Select Gender"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
          >
            {[
              { id: "Male", name: "Male" },
              { id: "Female", name: "Female" },
              { id: "Other", name: "Other" },
            ].map((item, index) => (
              <MenuItem key={index} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} mt={3}>
          <LoadingButton
            type="submit"
            variant="contained"
            fullWidth
            loading={formikProps.isSubmitting}
            disabled={!formikProps.dirty || !formikProps.isValid}
            style={{ padding: "10px 12.5px", fontWeight: 700 }}
          >
            Sign Up
          </LoadingButton>
        </Grid>
      </Grid>
    </Fragment>
  );
}
